export default "__VITE_ASSET__24656036__"